"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=e(require("styled-components")).default.nav`
  background: ${({theme:e})=>e.colors.common.light};
  position: sticky;
  top: 0;

  @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
    border-bottom: ${({theme:e,hasVisualizer:t,isHealthy:i})=>t&&i?"none":`solid 1px ${e.colors.grey[300]}`};
    background: transparent;
    position: relative;
  }

  .inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    max-width: ${({theme:e})=>e.widths.small};
    margin: auto;
    padding: 20px ${({theme:e})=>e.spacing.medium};
    width: 100%;
    box-sizing: border-box;
    position: relative;

    @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
      max-width: ${({theme:e})=>e.widths.xlarge};
    }

    .overview {
      display: none;
      width: max-content;

      @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
        display: block;
        position: ${({hasVisualizer:e,isHealthy:t})=>e&&t?"relative":"absolute"};
        margin-right: 50px;
      }

      button {
        color: ${({theme:e})=>e.colors.common.dark};
        text-decoration: none;
        border: none;
        background: transparent;
        text-align: left;
      }

      p {
        margin: 0;
        font-weight: 700;
      }

      h1 {
        margin: 0;
        display: grid;
        grid-auto-flow: column;
        grid-column-gap: 7px;
        width: max-content;

        svg {
          position: relative;
          top: 2px;
        }
      }
    }

    > ul {
      display: grid;
      grid-auto-flow: column;
      grid-column-gap: 53px;
      margin: auto;
      padding: 0;
      list-style: none;

      @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
        grid-column-gap: 10px;
        width: 100%;
        max-width: 355px;
      }

      > li {
        margin: 0;
        padding: 0;
        width: max-content;

        button {
          text-decoration: none;
          text-transform: none;
          color: ${({theme:e})=>e.colors.common.dark};
          opacity: 0.5;
          transition: all 0.4s ease-in-out;
          padding: 0;
          display: block;
          border-radius: 75px;
          font-weight: 700;
          border: none;
          background: transparent;
          cursor: pointer;

          @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
            font-size: ${({theme:e})=>e.typography.h5.fontSize};
            letter-spacing: ${({theme:e})=>e.typography.h5.letterSpacing};
            line-height: ${({theme:e})=>e.typography.h5.lineHeight};
            padding: 10px 18px;
          }

          &:hover,
          &:active,
          &:focus {
            opacity: 1;
          }

          &.active {
            color: ${({theme:e})=>e.colors.primary.default};
            opacity: 1;

            @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
              background: ${({theme:e,hasVisualizer:t,isHealthy:i})=>t&&i?"transparent":e.colors.common.light};
              box-shadow: ${({theme:e,hasVisualizer:t,isHealthy:i})=>t&&i?"none":e.shadows.colored};
            }
          }
        }
      }
    }
  }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
